const ContactSupportCard = () => {
    const supportEmail = "support@trevex.io";
  return (
    <div className="w-full bg-white border border-[#EAECF0] rounded-[16px] p-4 sm:p-6 mt-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        
        {/* Left content */}
        <div>
          <h3 className="text-[20px] font-semibold text-[#101828] text-left">
            Need Help? Contact Support
          </h3>
          <p className="text-[16px] text-[#667085] mt-1 text-left">
            Reach out to our team for assistance with setup, uploads, or any
            questions along the way.
          </p>
        </div>

        {/* CTA */}
        <button
        onClick={() =>
            (window.location.href = `mailto:${supportEmail}`)
          }
          className="
            w-full sm:w-auto
            px-6 py-3
            text-[18px] font-medium
            text-[#FF3B30]
            border border-[#FF3B30]
            rounded-[4px]
            hover:bg-red-50
            transition
          "
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default ContactSupportCard;
